<template lang="html">
  <div :class="{'aside-content': true, 'folded': !folding}">
    <div id="httpUpBtn1" style="position: absolute;top: -100000px;"></div>
    <div class="nav">
      <dl class="titleline">
        <h5>
          素材
          <img src="@assets/img/common/warning-gray.svg" alt="tip" class="tip">
          <p class="tips" v-html="file.description"></p>
        </h5>
        <span @click="fold()">{{pic.assets.length + video.assets.length + audio.assets.length}}<img :src="folding ? icons.upward: icons.downward" alt="icon"></span>
      </dl>
      <div v-show="folding" class="upFile">
        <!-- <div class="radio">
          <div class="radioBtn" v-show="hasAspera" :class="{active: uploadChannel === 'aspera'}" :disabled="uploadChannelDisable">
            <span @click="uploadChannel='aspera'"></span>
            <p>高速模式</p>
            <img class="asperaHelp" @click="openAsperaPage()" src="@assets/img/headline/help.svg" alt="help" title="aspera帮助页">
          </div>
          <div class="radioBtn" v-show="hasHttp" :class="{active: uploadChannel === 'http'}" :disabled="uploadChannelDisable">
            <span @click="uploadChannel='http'"></span>
            <p>普通模式</p>
          </div>
        </div>
        <input id="Upload[http]" type="file" class="hide" >
        <label for="Upload[http]" id="httpUpBtn" class="httpUpBtn" v-show="uploadChannel === 'http'" @mousedown="handlePageIdPromise()" @click.stop.prevent="">上传</label>
        <input id="Upload[aspera]" type="file" class="hide">
        <label for="Upload[aspera]" :class="{'AsperaUpBtn': true, 'disabled': aspera.needInstall}" v-show="uploadChannel === 'aspera'" @click.stop.prevent="asperaUpload()" @mousedown="handlePageIdPromise()">上传</label> -->
        <div class="btn-container">
          <div v-click-outside="closeUpload" v-show="hasHttp || hasAspera" :class="{'upload-container': true, rotate: showUpload}">
            <!-- <div id="httpUpBtn" @mousedown="handlePageIdPromise()" @click.stop.prevent="" v-show="uploadChannel=='http'&&user_space.is_upload_enabled" class="localUpload" style="display: flex;">
              <img src="@assets/img/common/add-green.svg">
              <p>本地上传</p>
              <img src="@assets/img/common/arrow-grey.svg">
            </div> -->

            <div @click="showUpload = !showUpload;showMaterialBox = false" v-show="uploadChannel=='http'" class="localUpload" style="display: flex;">
              <img src="@assets/img/common/add-green.svg">
              <p>本地上传</p>
              <img src="@assets/img/common/arrow-grey.svg">
            </div>

            <!-- <div @click="$fullTitle({title: '您的草稿空间已满', msg: '请在”我的素材“或草稿文稿中清除素材'})" v-if="uploadChannel=='http'&&!user_space.is_upload_enabled" class="localUpload" style="display: flex;">
              <img src="@assets/img/common/add-green.svg">
              <p>本地上传</p>
              <img src="@assets/img/common/arrow-grey.svg">
            </div> -->

            <!-- <div @click.stop.prevent="asperaUpload()" @mousedown="handlePageIdPromise()" v-show="uploadChannel=='aspera'&&user_space.is_upload_enabled" class="asperaUpload">
              <img src="@assets/img/common/add-green.svg">
              <p>高速通道</p>
              <img src="@assets/img/common/arrow-grey.svg">
            </div> -->

            <div @click="showUpload = !showUpload;showMaterialBox = false" v-show="uploadChannel=='aspera'" class="asperaUpload">
              <img src="@assets/img/common/lightningGreen.svg">
              <p>高速通道</p>
              <img src="@assets/img/common/arrow-grey.svg">
            </div>

            <!-- <div @click="$fullTitle({title: '您的草稿空间已满', msg: '请在”我的素材“或草稿文稿中清除素材'})" v-if="uploadChannel=='aspera'&&!user_space.is_upload_enabled" class="asperaUpload">
              <img src="@assets/img/common/add-green.svg">
              <p>高速通道</p>
              <img src="@assets/img/common/arrow-grey.svg">
            </div> -->

            <div v-show="showUpload&&user_space.is_upload_enabled" class="formatList">
              <p></p>
              <div class="format">
                <div id="httpUpBtn" style="display: flex !important" @click="uploadChannel='http';localUploadCover=false;showUpload=false;handlePageIdPromise()" v-show="hasHttp">
                  <img src="@assets/img/common/localUpload.svg">
                  <p>本地上传</p>
                </div>
                <div style="position: relative" @click="uploadChannel='aspera';showUpload=false;handlePageIdPromise()" v-show="hasAspera">
                  <img src="@assets/img/common/lightning.svg">
                  <p>高速通道</p>
                  <img class="asperaHelp" @click.stop="openAsperaPage()" src="@assets/img/headline/help.svg" alt="help" title="aspera帮助页">
                </div>
              </div>
            </div>

            <div v-show="showUpload&&!user_space.is_upload_enabled" class="formatList">
              <p></p>
              <div class="format">
                <div @click="$fullTitle({title: '您的草稿空间已满', msg: '请在”我的素材“或草稿文稿中清除素材'});showUpload=false" style="display: flex !important" v-show="hasHttp">
                  <img src="@assets/img/common/localUpload.svg">
                  <p>本地上传</p>
                </div>
                <div @click="$fullTitle({title: '您的草稿空间已满', msg: '请在”我的素材“或草稿文稿中清除素材'});showUpload=false" style="position: relative" v-show="hasAspera">
                  <img src="@assets/img/common/lightning.svg">
                  <p>高速通道</p>
                  <img class="asperaHelp" @click.stop="openAsperaPage()" src="@assets/img/headline/help.svg" alt="help" title="aspera帮助页">
                </div>
              </div>
            </div>
          </div>
          <div v-click-outside="closeMaterialBox" class="material-container">
            <div @click="showMaterialBox = !showMaterialBox;showUpload = false" :class="{material: true, materialBin: materialChannel=='materialBin',rotate: showMaterialBox}">
              <img v-if="materialChannel=='myMaterial'" src="@assets/img/common/menu-green.svg">
              <img v-if="materialChannel=='materialBin'" src="@assets/img/common/materialBinGreen.png">
              <p v-if="materialChannel=='myMaterial'">我的素材</p>
              <p v-if="materialChannel=='materialBin'">素材库</p>
              <img src="@assets/img/common/arrow-grey.svg">
            </div>
            
            <div v-show="showMaterialBox" class="formatList">
              <p></p>
              <div class="format">
                <div @click="materialChannel='myMaterial';showMore=true;showMaterialListBox();showMaterialBox=false">
                  <img src="@assets/img/common/myMaterial.png">
                  <p>我的素材</p>
                </div>
                <div @click="materialChannel='materialBin';showMore=true;showMaterialListBox();showMaterialBox=false">
                  <img src="@assets/img/common/marterialBin.png">
                  <p>素材库</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="upload">
        <div :class="{uploadList: true, 'pdt_10': file.list.filter(i => !i.hideasset).length > 0}">
          <div class="item" v-for="(v, i) in file.list" :key="i" v-show="!v.hideasset">
            <!-- <span class="pending" v-if="v.pending">入库中...</span> -->
            <span class="proportion">{{`${v.loaded||0}/${v.total||0}`}}</span>
            <span class="speed-box">
              <span :style="{width: `${v.percent}%`}"></span>
            </span>
            <i class="close" @click="newHandelCancelProgress(v)"></i>
          </div>
        </div>
      </div>
      <ul v-show="folding">
        <li :class="{active:navOn==0}" @click="navSwitch(0)">图片 <span>{{pic.assets.length}}</span></li>
        <li :class="{active:navOn==1}" @click="navSwitch(1)">视频 <span>{{video.assets.length}}</span></li>
        <li :class="{active:navOn==2}" @click="navSwitch(2)">音频 <span>{{audio.assets.length}}</span></li>
      </ul>
    </div>
    <div class="nav-content" v-show="folding">
      <div class="nav-item" v-show="navOn==0">
        <div class="item">
          <ul>
            <empty v-if="pic.assets.length === 0" :msg="'暂无图片'" />
            <li class="list" v-for="(p, d) in pic.assets" :key="d">
              <div class="info">
                <ul class="bottom">
                  <li>
                    <p>格式</p>
                    <span>{{p.content.type}}</span>
                  </li>
                  <li>
                    <p>大小</p>
                    <span>{{p.content.size}}</span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <p>高度</p>
                    <span>{{p.content.pixel}}</span>
                  </li>
                </ul>
              </div>
              <div class="row">
                <div class="pic" @click="openDetail(p)" @mouseenter='zoomIn' @mouseleave='zoomOut'>
                  <img @error="imgError(p)" class="cover" :src="p.cover || defaultImg" alt="img">
                  <div class="mask">查看更多</div>
                </div>
                <div class="c">
                  <textarea class="t" v-model="p.name" maxlength="40" @blur="renameAsset(p.idstring, p.name, pic.assets)"></textarea>
                  <span class="size">{{`${(p.name || '').length}/40`}}</span>
                </div>
                <div class="rm" @click="deleteAsset(p.idstring, pic.assets)">
                  <span></span>
                </div>
              </div>
              <div class="row1">
                <div v-if="quickEdit" class="add-qk append" :class={big:!canInsert} @click="addQKFile(p, 'img')">
                  <button>选用</button>
                </div>
                <div v-if="canInsert" class="append border" :class={big:!quickEdit} @click="insertPage(p, 'img')">
                  <button>插入正文</button>
                </div>
                <!-- <div v-if="canShowPicEdit" @click="editPic(p)" class="append border">
                  <button>编辑</button>
                </div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="nav-item" v-show="navOn==1">
        <div class="item">
          <ul>
            <empty v-if="video.assets.length === 0" :msg="'暂无视频'" />
            <li class="list" v-for="(va, i) in video.assets" :key="i">
              <div class="info">
                <ul class="bottom">
                  <li>
                    <p>格式</p>
                    <span>{{va.content.format}}</span>
                  </li>
                  <li>
                    <p>时长</p>
                    <span>{{va.content.duration}}</span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <p>大小</p>
                    <span>{{va.content.file_size}}</span>
                  </li>
                  <li>
                    <p>尺寸</p>
                    <span>{{va.content.resolution}}</span>
                  </li>
                </ul>
              </div>
              <div class="row">
                <div class="pic" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="openDetail(va)">
                <div class='verify-success verify-item'  v-if="va.has_audit&&va.has_audit==1">
                  <img alt="技审通过" title="技审通过" class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
                </div>
                <div class='verify-fail verify-item' v-if="va.has_audit&&va.has_audit==2">
                  <img alt="技审未通过" title="技审未通过" class="verify-logo"  src="@assets/img/common/verify-fail-logo.svg">
                </div>
                  <img v-if="va['content']&&va['content'].cover" src="@assets/img/common/play.svg" alt="play" class="play">
                  <img class="cover" :src="va['content']?(va.cover||defaultMedia): defaultMedia" alt="cover">
                  <div class="mask">查看更多</div>
                </div>
                <div class="c">
                  <textarea class="t" maxlength="40" v-model="va.name" @blur="renameAsset(va.idstring, va.name, video.assets)"></textarea>
                  <span class="size">{{`${va.name && va.name.length}/40`}}</span>
                </div>
                <div class="rm" @click="deleteAsset(va.idstring, video.assets)">
                  <span></span>
                </div>
              </div>
              <div class="row1">
                <div v-if="quickEdit" class="add-qk append" :class={big:!canInsert} @click="addQKFile(va, 'video')">
                  <button>选用</button>
                </div>
                <div v-if="canInsert" :class={big:!quickEdit} class="append border" @click="insertPage(va, 'video')">
                  <button>插入正文</button>
                </div>
                <!-- <div v-if="canShowPicEdit" @click="editPic(p)" class="append border">
                  <button>编辑</button>
                </div> -->
              </div>
              <!-- todo 待删 -->
              <div class="append video" v-if="false">
                <!-- todo 详细不需要了 -->
                <button class="de" v-if="false">
                  详细
                  <div class="detail">
                    <div class="line">
                      <p class="item">
                        <span>格式</span>
                        <span class="txt">{{va['content']?va['content'].format:''}}</span>
                      </p>
                      <p class="item">
                        <span>时长</span>
                        <span class="txt">{{va['content']?va['content'].duration:''}}</span>
                      </p>
                    </div>
                    <div class="line">
                      <p class="item">
                        <span>大小</span>
                        <span class="txt">{{va['content']?va['content'].file_size:''}}</span>
                      </p>
                      <p class="item">
                        <span>宽度</span>
                        <span class="txt">{{va['content']?va['content'].resolution:''}}</span>
                      </p>
                    </div>
                    <div class="line">
                      <p class="item">
                        <span>码率</span>
                        <span class="txt">{{va['content']?va['content'].rate:''}}</span>
                      </p>
                      <p class="item">
                        <span></span>
                        <span></span>
                      </p>
                    </div>
                  </div>
                </button>
                <div v-if="quickEdit" class="add-qk append" @click="addQKFile(va, 'video')">
                  <button>选用</button>
                </div>
                <button v-if="canInsert" @click="insertPage(va, 'video')">插入正文</button>
                <!-- <button v-if="va.text_status == 1 && canComposite" class="wh" @click="convertWord(va)">视频转文字</button> -->
                <!-- <button v-if="va.text_status == 2 && canComposite" class="wh"><img src="@assets/img/common/loading-g.svg" alt="loading" class="loading" />转文字中</button> -->
                <!-- <button v-if="va.text_status == 3 && canComposite" class="wh" @click="goWord(va.idstring, 'video')">查看文字</button> -->
                <!-- <button v-if="va.text_status == 4 && canComposite" class="fail" @click="convertWord(va)" @mouseover.stop="hoverFailBtn(va, true)" @mouseout.stop="hoverFailBtn(va, false)">{{va.hover ? '视频转文字' : '转码失败'}}</button> -->
              </div>
            </li>
            <li></li>
          </ul>
        </div>
      </div>
      <div class="nav-item" v-show="navOn==2">
        <div class="item">
          <ul>
            <empty v-if="audio.assets.length === 0" :msg="'暂无音频'" />
            <li class="list" v-for="(sa, i) in audio.assets" :key="i">
              <div class="info">
                <ul class="bottom">
                  <li>
                    <p>格式</p>
                    <span>{{sa.content.format}}</span>
                  </li>
                  <li>
                    <p>时长</p>
                    <span>{{sa.content.duration}}</span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <p>大小</p>
                    <span>{{sa.content.file_size}}</span>
                  </li>
                  <li>
                    <p>声道</p>
                    <span>{{sa.content.track}}</span>
                  </li>
                </ul>
              </div>
              <div class="row">
                <div class="pic" @click="openDetail(sa)" @mouseenter='zoomIn' @mouseleave='zoomOut'>
                  <img class="cover" :src="sa['content']?(sa['content'].cover ||defaultMedia):defaultMedia" alt="cover">
                  <div class="mask">查看更多</div>
                </div>
                <div class="c">
                  <textarea class="t" maxlength="40" v-model="sa.name" @blur="renameAsset(sa.idstring, sa.name, audio.assets)"></textarea>
                  <span class="size">{{`${sa.name && sa.name.length}/40`}}</span>
                </div>
                <div class="rm" @click="deleteAsset(sa.idstring, audio.assets)">
                  <span></span>
                </div>
              </div>
               <div class="row1">
                <div v-if="quickEdit" class="add-qk append" :class={big:!canInsert} @click="addQKFile(sa, 'audio')">
                  <button>选用</button>
                </div>
                <div v-if="canInsert" class="append border" :class={big:!quickEdit} @click="insertPage(sa, 'audio')">
                  <button>插入正文</button>
                </div>
                <!-- <div v-if="canShowPicEdit" @click="editPic(p)" class="append border">
                  <button>编辑</button>
                </div> -->
              </div>
              <div class="append video" v-if='false'>
                <button class="de" :class="{hasEdit: canShowEdit}">
                  详细
                  <div class="detail">
                    <div class="line">
                      <p class="item">
                        <span>格式</span>
                        <span class="txt">{{sa['content']?sa['content'].format:''}}</span>
                      </p>
                      <p class="item">
                        <span>时长</span>
                        <span class="txt">{{sa['content']?sa['content'].duration:''}}</span>
                      </p>
                    </div>
                    <div class="line">
                      <p class="item">
                        <span>码率</span>
                        <span class="txt">{{sa['content']?sa['content'].rate:''}}</span>
                      </p>
                      <p class="item">
                        <span>大小</span>
                        <span class="txt">{{sa['content']?sa['content'].file_size:''}}</span>
                      </p>
                    </div>
                    <div class="line">
                      <p class="item">
                        <span>声道</span>
                        <span class="txt">{{sa['content']?sa['content'].track:''}}</span>
                      </p>
                      <p class="item">
                        <span></span>
                        <span></span>
                      </p>
                    </div>
                  </div>
                </button>
                <div v-if="quickEdit" class="add-qk append" @click="addQKFile(sa, 'audio')">
                  <button>选用</button>
                </div>
                <button v-if="canInsert" :class="{buttonHasEdit: canShowEdit}" @click="insertPage(sa, 'audio')">插入正文</button>
                <!-- <button v-if="sa.text_status == 1 && canComposite && canShowEdit" class="wh" :class="{smallButtonHasEdit: canShowEdit}" @click="convertWord(sa)">转文字</button>
                <button v-if="sa.text_status == 1 && canComposite && canShowEdit == false" class="wh" @click="convertWord(sa)">语音转文字</button>
                <button v-if="sa.text_status == 2 && canComposite" class="wh" :class="{longButtonHasEdit: canShowEdit}"><img src="@assets/img/common/loading-g.svg" alt="loading" class="loading" />转文字中</button>
                <button v-if="sa.text_status == 3 && canComposite" class="wh" @click="goWord(sa.idstring, 'audio')">查看文字</button>
                <button v-if="sa.text_status == 4 && canComposite" class="fail" @click="convertWord(sa)" @mouseover.stop="hoverFailBtn(sa, true)" @mouseout.stop="hoverFailBtn(sa, false)">{{sa.hover ? '音频转文字' : '转码失败'}}</button>
                <button v-if="canShowEdit" :class="{smallButtonHasEdit: canShowEdit}" @click="voiceEdit(sa.text_status,sa)">编辑</button> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as config from "@common/config";
import common from "@common/common";
import empty from "@components/empty";
import vClickOutside from 'v-click-outside';
import store from "@common/store";
import Upload from '@common/newUpload'

export default {
  name: "mediaCenter",
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    empty
  },
  data() {
    return {
      newConfig: {},
      fileMaxSize: 10,
      upload_limit_num: 10,
      cancel_enable: false,
      localUploadCover: false,
      showMore: true,
      showUpload: false,
      showMaterialBox:false,
      user_space: {},
      checkFailTime: 0,
      getPageIdPromise: null,
      navOn: 0,
      folding: true,
      pageId: "",
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/defaultMedia.png"),
      defaultAudio: require("@assets/img/common/defaultAudio.png"),
      icons: {
        downward: require("@assets/img/common/xiala.svg"),
        upward: require("@assets/img/common/upward.svg")
      },
      baseUrl: "",
      appId: "",
      appSecret: "",
      uploading: false,
      uploadChannel: "http",
      materialChannel: "myMaterial",
      uploadChannelDisable: false,
      baseConfig: {
        customered: true,
        autoUploading: true,
        multipleFiles: true,
        retryCount: 3,
        tokenURL: "",
        uploadURL: "",
        postVarsPerFile: {
          appId: "",
          appSecret: ""
        },
        onMaxSizeExceed: f => {
          this.$toast("文件大小超出限制");
        },
        onCancel: f => {
          console.log("cancel", f);
        },
        onExtNameMismatch: () => {
          this.$toast("无法上传不支持的格式");
        }
      },
      pic: {
        // 图片部分数据模型
        types: [],
        assets: []
      },
      video: {
        // 视频部分数据模型
        types: [],
        assets: []
      },
      audio: {
        // 音频部分数据模型
        types: [],
        assets: []
      },
      file: {
        // 文件部分数据模型
        title: "文件",
        description: "",
        stream: null,
        stream1: null,
        list: [],
        cancelOne: f => {
          if (f.pending) {
            this.deleteAsset(f.idstring, this.file.list);
            return;
          }

          if (this.file.stream) {
            try {
              if(this.localUploadCover){
                this.file.stream1.cancelOne(f.id);
              }else{
                this.file.stream.cancelOne(f.id);
              }
            } catch (error) {
              console.log("stream取消出错", error);
            }

            this.delItem(this.file.list, f.id);
          }
        },
        config: {
          browseFileId: "httpUpBtn",
          extFilters: [],
          maxSize: this.fileMaxSize * 1024 * 1024 * 1024,
          onQueueComplete: m => {
            // this.$toast('所有文件已上传完成')
            // this.uploading = false
            // this.passUploading()
          },
          onComplete: f => {
            this.file.stream.cancelOne(f.id);

            f.targetPath = JSON.parse(f.msg).targetPath;
            this.file.list.forEach(i => {
              if (i.id === f.id) {
                i.targetPath = f.targetPath;
                this.$set(i, "hideasset", true);
              }
            });

            // this.addAssetsToPage([f])
            this.addFilePromises.push(this.addAssetsToPage([f]));
          },
          onUploadError: f => {
            this.$toast("文件上传出错");
          },
          onSelect: f => {
            console.log(f)
            // 视音频数量限制10个（待添加），超出：stream.stop(), stream.cancel()
            setTimeout(() => {
              let status = this.checkFileCountCancel(f);
              // const materialType = this.checkFileType(f);
              let materialType = false;
              f.forEach(el => {
                if(this.checkFileType(el)!=1){
                  materialType = true
                }
              })

              if (!status) {
                return;
              }

              if(this.localUploadCover && materialType){
                this.$toast('请上传图片文件')
                this.file.stream.stop();
                this.file.stream.cancel();
                return;
              }

              f = this.filterFiles(f, this.file.config.maxSize);

              let totalList = this.file.list.concat(f);
              const allTypes = this.pic.types
                .concat(this.video.types)
                .concat(this.audio.types);
              totalList = totalList.filter(i => allTypes.indexOf(i.ext) > -1);
              this.file.list = Array.from(new Set(totalList));
            }, 0);
          },
          onUploadProgress: f => {
            this.uploading = true;
            this.passUploading();
            this.handleProgress(this.file.list, f);
          }
        },
        config1: {
          browseFileId: "httpUpBtn1",
          extFilters: [],
          maxSize: 10 * 1024 * 1024 * 1024,
          onQueueComplete: m => {
            // this.$toast('所有文件已上传完成')
            // this.uploading = false
            // this.passUploading()
          },
          onComplete: f => {
            this.file.stream1.cancelOne(f.id);

            f.targetPath = JSON.parse(f.msg).targetPath;
            this.file.list.forEach(i => {
              if (i.id === f.id) {
                i.targetPath = f.targetPath;
                this.$set(i, "hideasset", true);
              }
            });

            // this.addAssetsToPage([f])
            this.addFilePromises.push(this.addAssetsToPage([f]));
          },
          onUploadError: f => {
            this.$toast("文件上传出错");
          },
          onSelect: f => {
            console.log(f)
            // 视音频数量限制10个（待添加），超出：stream.stop(), stream.cancel()
            setTimeout(() => {
              const status = this.checkFileCount(f);
              // const materialType = this.checkFileType(f);
              let materialType = false;
              f.forEach(el => {
                if(this.checkFileType(el)!=1){
                  materialType = true
                }
              })

              if (!status) {
                this.file.stream1.stop();
                this.file.stream1.cancel();
                return;
              }

              if(this.localUploadCover && materialType){
                this.$toast('请上传图片文件')
                this.file.stream1.stop();
                this.file.stream1.cancel();
                return;
              }

              f = this.filterFiles(f, this.file.config1.maxSize);

              let totalList = this.file.list.concat(f);
              const allTypes = this.pic.types
                .concat(this.video.types)
                .concat(this.audio.types);
              totalList = totalList.filter(i => allTypes.indexOf(i.ext) > -1);
              this.file.list = Array.from(new Set(totalList));
            }, 0);
          },
          onUploadProgress: f => {
            this.uploading = true;
            this.passUploading();
            this.handleProgress(this.file.list, f);
          }
        }
      },
      aspera: {
        // aspera通道上传
        needInstall: false,
        files: [],
        filetypes: [],
        maxSize: 10 * 1024 * 1024 * 1024,
        checkInstalled: null,
        config: {
          host: "",
          userName: "",
          userPassword: "",
          deviceID: ""
        },
        start: f => {
          console.log("aspera uploading");
          const current = {
            remote_host: this.aspera.config.host,
            remote_user: this.aspera.config.userName,
            remote_password: common.hex2str(this.aspera.config.userPassword),
            create_dir: true,
            direction: "send",
            needs_destination: "",
            paths: [
              {
                source: f.name,
                destination: f.serverpath
              }
            ]
          };
          const params = {
            allow_dialogs: false
          };

          fileControls.asperaWeb.startTransfer(current, params, {
            error: responseData => {
              let userMessage = responseData.error.user_message;
              this.$toast(userMessage);
            },
            success: res => {
              console.log("start", res);
            }
          });
        },
        complete: f => {
          f.targetPath = f.serverpath;
          this.file.list.forEach(i => {
            if (i.id === f.id) {
              this.$set(i, "hideasset", true);
            }
          });
          console.log(123123);
          // this.addAssetsToPage([f])
          this.addFilePromises.push(this.addAssetsToPage([f]));
        },
        delete: f => {
          // 删除上传过程中的文件
          if (f.pending) {
            this.deleteAsset(f.idstring, this.file.list);
            return;
          } else {
            fileControls.asperaWeb.removeTransfer(f.uuid);
            this.delItem(this.file.list, f.id);
          }
        }
      },
      addFilePromises: [],
      hasHttp: false,
      hasAspera: false,
      file_format_types: {}
    };
  },
  computed: {
    quickEdit() {
      console.log("quickEdit", this.$store.state.quickEdit);
      return this.$store.state.quickEdit;
    }
  },
  props: {
    pageType: {
      type: Number,
      required: true
    },
    data: {
      type: Object
    },
    select: {
      type: Object
    },
    getFold: {
      type: Function
    },
    canComposite: {
      type: Boolean,
      default: false
    },
    canInsert: {
      type: Boolean,
      default: false
    },
    canShowEdit: {
      type: Boolean,
      default: false
    },
    canShowPicEdit: {
      type: Boolean,
      default: false
    },
    isPublishSrc: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "$store.state.flashPic1": function (el) {
      console.log(el);
      if (el) {
        console.log(el);
        this.getFlashfile();
        this.$store.commit("setflashPic1", false);
      }
    },
    "$store.state.user_space": function (el) {
      this.user_space = el
    },
    data: function (n) {
      if (n) {
        this.receiveData();
      }
    },
    uploadChannel: function (n) {
      this.checkFailTime = 0;
      this.handleUploadChannel(n);
    },
    file: {
      deep: true,
      handler: function (n) {
        const list = n.list.filter(i => !i.hideasset);

        if (list.length === 0) {
          this.uploadChannelDisable = false;
        } else {
          this.uploadChannelDisable = true;
        }
      }
    },
    addFilePromises: {
      deep: true,
      handler: function (n) {
        const leftWithoutPending = this.file.list.filter(
          l => !l.pending && !l.hideasset
        ).length;

        Promise.all(n).then(() => {
          if (leftWithoutPending === 0) {
            console.log("真真真真真真真真上传完成");
            this.uploading = false;
            this.passUploading();
            this.$emit("getComplete", "");
          }
        });
      }
    }
  },
  methods: {
    closeUpload() {
      this.showUpload = false;
    },
    closeMaterialBox() {
      this.showMaterialBox = false;
    },
    imgError(p) {
      p.cover = this.defaultImg
    },
    editPic(i) {
      i.t = this.pageType;
      i.d = this.$route.query.d;
      this.$picEditType(i, this.getFileAssets).then(res => { });
    },
    voiceEdit(i, j) {
      console.log("voiceEdit", i, j);
      let newObj = {
        pageType: this.pageType,
        pageId: this.$route.query.d,
        file_format: this.file_format_types,
        appId: this.appId,
        appSecret: this.appSecret
      };
      Object.assign(j, newObj);
      this.$voiceEditType(i, j).then(res => {
        console.log(res, i);
        if (res == 0 && i == 3 && res !== false) {
          // console.log(this.pageType,this.$route.query.d,j)
          const newWindow = window.open();
          // console.log(`${window.location.origin}/voiceEdit/${this.pageType}/${this.$route.query.d}/${j.idstring}`)
          newWindow.location.href = `${window.location.origin
            }/voiceEdit/${this.pageType}/${this.$route.query.d}/${j.idstring
            }`;
        } else if (res == "peComplete") {
          this.getFileAssets(true);
        }
      });
    },
    checkFileCountCancel(files) {
      let status = true;
      const imgs = []
      const videos = [];
      const audios = [];
      files.forEach(i => {
        let ext = i.name.split(".").pop();
        ext = ext.toLowerCase();
        i.ext = ext;
        if (this.pic.types.indexOf(ext) > -1) {
          imgs.push(i)
        } else if (this.video.types.indexOf(ext) > -1) {
          videos.push(i);
        } else if (this.audio.types.indexOf(ext) > -1) {
          audios.push(i);
        }
      });

      const imgStatus = this.checkImgCountCancel(imgs)
      const videoStatus = this.checkVideoCountCancel(videos);
      const audioStatus = this.checkAudioCountCancel(audios);

      status = imgStatus && videoStatus && audioStatus;

      if (!status) {
        this.$toast("图片音视频素材不能超过"+this.upload_limit_num+"个");
      }

      return status;
    },
    checkImgCountCancel(imgs) {
      // 检测图片数量
      let status = true;
      const queuelength = this.file.list.filter(
        i => this.pic.types.indexOf(i.ext) > -1 && !i.hideasset
      ).length;
      const assetslength = this.pic.assets.length;
      const selectlength = imgs.length;
      if (queuelength + assetslength + selectlength > this.upload_limit_num) {
        status = false;
      }

      // if(!status){
      //   imgs.forEach(el => {
      //     this.file.stream.cancelOne(el.id);
      //   })
      // }

      return status;
    },
    checkVideoCountCancel(videos) {
      // 检测视频数量
      let status = true;
      const queuelength = this.file.list.filter(
        i => this.video.types.indexOf(i.ext) > -1 && !i.hideasset
      ).length;
      const assetslength = this.video.assets.length;
      const selectlength = videos.length;
      if (queuelength + assetslength + selectlength > this.upload_limit_num) {
        status = false;
      }

      // if(!status){
      //   videos.forEach(el => {
      //     this.file.stream.cancelOne(el.id);
      //   })
      // }

      return status;
    },
    checkAudioCountCancel(audios) {
      // 检测音频数量
      let status = true;
      const queuelength = this.file.list.filter(
        i => this.audio.types.indexOf(i.ext) > -1 && !i.hideasset
      ).length;
      const assetslength = this.audio.assets.length;
      const selectlength = audios.length;
      if (queuelength + assetslength + selectlength > this.upload_limit_num) {
        status = false;
      }

      // if(!status){
      //   audios.forEach(el => {
      //     this.file.stream.cancelOne(el.id);
      //   })
      // }

      return status;
    },
    checkFileCount(files) {
      // 检查素材数量，每种素材都不超过10个才能通过检查
      let status = true;
      const imgs = []
      const videos = [];
      const audios = [];
      files.forEach(i => {
        let ext = i.name.split(".").pop();
        ext = ext.toLowerCase();
        i.ext = ext;
        if (this.pic.types.indexOf(ext) > -1) {
          imgs.push(i)
        } else if (this.video.types.indexOf(ext) > -1) {
          videos.push(i);
        } else if (this.audio.types.indexOf(ext) > -1) {
          audios.push(i);
        }
      });

      const imgStatus = this.checkImgCount(imgs)
      const videoStatus = this.checkVideoCount(videos);
      const audioStatus = this.checkAudioCount(audios);

      status = imgStatus && videoStatus && audioStatus;

      if (!status) {
        this.$toast("图片音视频素材不能超过"+this.upload_limit_num+"个");
      }

      return status;
    },
    checkImgCount(imgs) {
      // 检测图片数量
      let status = true;
      const queuelength = this.file.list.filter(
        i => this.pic.types.indexOf(i.ext) > -1 && !i.hideasset
      ).length;
      const assetslength = this.pic.assets.length;
      const selectlength = imgs.length;
      if (queuelength + assetslength + selectlength > this.upload_limit_num) {
        status = false;
      }

      return status;
    },
    checkVideoCount(videos) {
      // 检测视频数量
      let status = true;
      const queuelength = this.file.list.filter(
        i => this.video.types.indexOf(i.ext) > -1 && !i.hideasset
      ).length;
      const assetslength = this.video.assets.length;
      const selectlength = videos.length;
      if (queuelength + assetslength + selectlength > this.upload_limit_num) {
        status = false;
      }

      return status;
    },
    checkAudioCount(audios) {
      // 检测音频数量
      let status = true;
      const queuelength = this.file.list.filter(
        i => this.audio.types.indexOf(i.ext) > -1 && !i.hideasset
      ).length;
      const assetslength = this.audio.assets.length;
      const selectlength = audios.length;
      if (queuelength + assetslength + selectlength > this.upload_limit_num) {
        status = false;
      }

      return status;
    },
    convertByteToGb(n) {
      // 将字节转换为GB
      return n / 1024 / 1024 / 1024;
    },
    handlePageIdPromise() {
      console.log(9999)
      if (this.uploadChannel === "aspera" && this.aspera.needInstall) return;

      const id = this.pageId || this.$route.query.d;

      if (!id && !this.getPageIdPromise) {
        this.getPageIdPromise = this.getTempId();
      }
    },
    hoverFailBtn(item, status) {
      // 转码失败按钮鼠标事件
      this.$set(item, "hover", status);
    },
    async handelCancelProgress(f) {
      // 删除上传列表中文件
      if (f.uuid) {
        await this.aspera.delete(f);
        console.log(this.file.list.length)
        if(this.file.list.length == 0){
          this.uploading = false;
        }
      } else {
        if(this.cancel_enable){
          const info = {
            token: f.parameters.token
          }
          common.myFetch(config.apis.File_cancel, info).then(e => {
            // console.log(e)
          })
        }
        this.file.cancelOne(f);
      }
      // 检测队列剩余资源，如果为空则需要恢复uploading状态
      const leftWithoutPending = this.file.list.filter(
        l => !l.pending && !l.hideasset
      ).length;
      if (leftWithoutPending === 0) {
        this.uploading = false;
        this.passUploading();
      }
    },
    async newHandelCancelProgress(f) {
      // 删除上传列表中文件
      if (f.uuid) {
        await this.aspera.delete(f);
        console.log(this.file.list.length)
        if(this.file.list.length == 0){
          this.uploading = false;
        }
      } else {
        if(this.cancel_enable){
          let i = {
              token: f.token
          }
          common.myFetch(config.apis.newUploadcancel,i).then(res => {
              console.log(res)
          })
        }
        this.file.stream.cancelUpload(f.tid);
      }
      // 检测队列剩余资源，如果为空则需要恢复uploading状态
      const leftWithoutPending = this.file.list.filter(
        l => !l.pending && !l.hideasset
      ).length;
      if (leftWithoutPending === 0) {
        this.uploading = false;
        this.passUploading();
      }
    },
    getAsperaConfig() {
      // 获取aspera上传配置
      return common.myFetch(config.apis.File_Aspera).then(r => {
        if (r) {
          const types = r.file_format;
          this.file_format_types = types;
          if(r.upload_limit_num){
            this.upload_limit_num = Number(r.upload_limit_num)
          }
          this.$emit("getConfig", r);
          this.hasHttp = r.normal_upload;
          this.hasAspera = r.aspera_upload;
          this.pic.types = types.image;
          this.video.types = types.video;
          this.audio.types = types.audio;
          // window._XN_upVdoTps = types.video // 视频格式前缀为source，此处为传入streamjs
          this.aspera.config = r.upload_config;
          const filetypes = types.image.concat(types.video).concat(types.audio);
          this.aspera.filetypes = filetypes;
          const extFilters = filetypes.map(f => `.${f}`);
          const extFilters1 = types.image.map(f => `.${f}`);
          this.file.config.extFilters = extFilters;
          this.file.config1.extFilters = extFilters1;

          this.file.config.maxSize =
            r.file_format.file_size || this.file.config.maxSize;
          this.file.config1.maxSize =
            r.file_format.file_size || this.file.config1.maxSize;
          this.aspera.maxSize = r.file_format.file_size || this.aspera.maxSize;

          this.file.description = `素材格式：${filetypes.join(
            ","
          )} <br><br> 视频、音频每种素材不超过10个，单个素材不超过${this.convertByteToGb(
            this.aspera.maxSize
          )}GB`;

          this.fileMaxSize = this.convertByteToGb(this.aspera.maxSize)

          window._XN_upCfg = {
            asperaPath: r.aspera_path,
            httpPath: r.original_path,
            fileNameId: r.filename_id
          };
        }
      });
    },
    generateServerPath(f) {
      // 生成服务器端路径
      let serverpath = "";
      const uniname = common.uniKey();
      // const year = new Date().getFullYear()
      // const month = common.doubleDigit(new Date().getMonth() + 1)
      // const day = common.doubleDigit(new Date().getDate())
      const platform = common.getPlatform();
      const ext = f.filename.split(".").pop();
      const asperaPath = window._XN_upCfg.asperaPath;
      const fileNameId = window._XN_upCfg.fileNameId;
      const path = `${asperaPath}/${fileNameId}${platform}${uniname}.${ext}`;
      f.id = uniname;
      serverpath = path;

      return serverpath;
    },
    asperaUpload() {
      if (this.uploading) return;
      fileControls.asperaWeb.showSelectFileDialog({
        success: res => {
          const files = [];
          // 音视频数量限制10个（待添加）
          const fileCountStatus = this.checkFileCount(res.dataTransfer.files);
          if (!fileCountStatus) return;

          res.dataTransfer.files.forEach(i => {
            if (i.size <= this.aspera.maxSize) {
              let ext = i.name.split(".").pop();
              ext = ext.toLowerCase();
              // const types = this.aspera.filetypes
              if (this.aspera.filetypes.indexOf(ext) === -1) {
                this.$toast("无法上传不支持的格式");
              } else {
                i.filename = this.__parseFileName(i.name);
                i.serverpath = this.generateServerPath(i);
                i.percent = 0;
                files.push(i);
              }
            } else {
              this.$toast("上传文件不能超出限制");
            }
          });

          this.aspera.files = files;
          this.file.list = this.aspera.files.concat(this.file.list);
          if (this.aspera.files.length > 0) {
            this.uploading = true;
            this.passUploading();
          }
          this.aspera.files.forEach(f => {
            this.aspera.start(f);
          });
        }
      });
      // fileControls.showSelectFileDialog(document.body, config, moid, userid, true);
    },
    __parseFileName(path) {
      // 解析文件路径中的文件名
      if (/Win/.test(navigator.platform)) {
        return path.substring(path.lastIndexOf("\\") + 1);
      } else {
        return path.substring(path.lastIndexOf("/") + 1);
      }
    },
    resetAsperaCheck() {
      // 重置aspera检测，恢复初始状态
      if (this.aspera.checkInstalled) {
        clearTimeout(this.aspera.checkInstalled);
        this.aspera.checkInstalled = null;
        this.$set(this.aspera, "needInstall", false);
      }
    },
    handleUploadChannel(c) {
      if (c === "aspera") {
        if(this.uploading) return
        this.uploadChannel = 'http'
        this.$set(this.aspera, "needInstall", true);
        this.loadAspera().then(() => {
          const container = $(document.body);
          fileControls.initAsperaConnect(container, (installed, updatable) => {
            // 检测aspera插件是否安装可用
            if (!installed) {
              // this.$toast('请安装aspera客户端')
              this.$set(this.aspera, "needInstall", true);
              this.checkFailTime++;
              this.aspera.checkInstalled =
                this.aspera.checkInstalled || 
                setTimeout(() => {
                  this.handleUploadChannel(c);
                }, 1000);

              if (this.checkFailTime == 5) {
                clearTimeout(this.aspera.checkInstalled);
                this.aspera.checkInstalled = null;
                this.uploadChannel = "http";
                this.$confirm(
                  "未检测到高速上传插件，暂时无法使用该服务是否前往下载该插件？"
                ).then(r => {
                  if (r) {
                    window.open(config.asperapage, true);
                  }
                });
              }
            }

            if (updatable) {
              this.$toast("请升级到最新客户端");
            }

            if (installed) {
              this.$set(this.aspera, "needInstall", false);
              this.resetAsperaCheck();
              this.asperaUpload();

              fileControls.asperaWeb.addEventListener(
                "transfer",
                (e, status) => {
                  // console.log(e, status)
                  if (status.result_count <= 0) return;
                  const filelist = status.transfers.filter(
                    i => i.current_file || i.status == "completed"
                  );
                  this.handleAsperaProgress(filelist);
                }
              );
            }
            // 检测aspera插件是否安装可用
          });
        });
      } else {
        console.log("httptttttttttttttt");
        this.resetAsperaCheck();
      }
    },
    openAsperaPage() {
      window.open(config.asperapage, true);
    },
    handleAsperaProgress(list) {
      // console.log(list)
      this.file.list.forEach(i => {
        list.forEach(j => {
          console.log(i,j)
          if (!i.hideasset && i.filename === j.title) {
            if (j.status === "failed") {
              this.$toast(j.error_desc);
              return;
            }
            console.log(j)
            this.$set(i, "percent", j.percentage * 100);
            this.$set(i, "total", this.rcsDvs(j.bytes_expected));
            this.$set(i, "loaded", this.rcsDvs(j.bytes_written));
            this.$set(i, "title", j.title);
            this.$set(i, "uuid", j.uuid);
            if (j.status === "completed") {
              this.aspera.complete(i);
              console.log("complete", i);
            }
          }
        });
      });
    },
    loadAspera() {
      return Promise.all([this.loadJQ(), this.loadAW4()]).then(() => {
        return this.loadAW4Config().then(() => {
          return this.loadAsperaJS();
        });
      });
    },
    loadAsperaJS() {
      // 加载js文件
      if (window.fileControls) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.asperajs);
    },
    loadAW4() {
      if (window.AW4) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.aw4js);
    },
    loadAW4Config() {
      if (window.AW4.ConnectInstaller) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.aw4config);
    },
    loadJQ() {
      if (window.$) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.jqjs);
    },
    rcsDvs(number) {
      // 根据aspera上传过程数据转换数字为对应单位
      number = number / 1024;
      if (number > 1024) {
        number = number / 1024;
        if (number > 1024) {
          number = number / 1024;

          return `${number.toFixed(2)}G`;
        }

        return `${number.toFixed(2)}M`;
      }

      return `${number.toFixed(2)}K`;
    },
    passUploading() {
      this.$emit("getUploading", this.uploading);
    },
    checkFileType(f) {
      // 检查文件类型
      let type = "";
      let ext = f.name.split(".").pop() || f.path.split(".").pop();
      ext = ext.toLowerCase();

      if (this.pic.types.indexOf(ext) > -1) {
        type = 1;
      } else if (this.video.types.indexOf(ext) > -1) {
        type = 2;
      } else if (this.audio.types.indexOf(ext) > -1) {
        type = 3;
      }
      return type;
    },
    async openDetail(item) {
      console.log("store create", this.$store.state.create,item);
      let config = {
        type: item.type,
        id: item.id,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        canEdit: true,
        t: Number(this.pageType),
        d: this.$route.query.d
      };
      if (!item.trans_finish) {
        this.$toast("转码中，暂时无法预览");
        return;
      }

      // const listWrap = {
      //   img_list: this.pic.assets,
      //   video_list: this.video.assets.filter(i => {
      //     return i.content && i.content.status == 1;
      //   }),
      //   sound_list: this.audio.assets.filter(i => {
      //     return i.content && i.content.status == 1;
      //   })
      // };

      const listWrap = {
        img_list: this.pic.assets,
        video_list: this.video.assets,
        sound_list: this.audio.assets
      };

      let list = await common.getAllMedia1(listWrap);
      console.log("拿完所有list", list);
      // list 有id即可
      let index = list.findIndex(e => e.id == item.id);
      console.log("index", index);

      let mediaDetailConfig = {
        index,
        list,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        canEdit: true
      }

      mediaDetailConfig = JSON.stringify(mediaDetailConfig)

      store.commit("setDetailConfig", mediaDetailConfig);

      common.jump('/mediaDetail?t='+Number(this.pageType)+'&d='+this.$route.query.d,true)
      // this.$materialBox(config, this.getFileAssets, {
      //   index,
      //   list,
      //   quickEdit: this.quickEdit,
      //   create: this.$store.state.create,
      //   canEdit: true,
      //   t: Number(this.pageType),
      //   d: this.$route.query.d
      // });
    },
    goViewer(item) {
      console.log("goViewer", item);
      // 媒体浏览器
      if (item.type != 1 && (!item.content || item.content.status != 1)) {
        this.$toast("转码中，暂时无法预览");
        return;
      }

      const data = {
        img_list: this.pic.assets,
        video_list: this.video.assets.filter(i => {
          return i.content && i.content.status == 1;
        }),
        sound_list: this.audio.assets.filter(i => {
          return i.content && i.content.status == 1;
        })
      };
      const now = {
        url: item.url,
        type: item.type - 0,
        downloadUrl: item.download_url
      };

      common.viewMedia(data, now);
    },
    goWord(idstring, type) {
      let url = `/videotoword?d=${idstring}`;
      if (type === "audio") {
        url = `/audiotoword?d=${idstring}`;
      }

      common.jump(url, true);
    },
    getTempId() {
      // 获取报道 1／线索 0/ 发布 2 临时id
      const info = {
        submit_act: "upload",
        type: this.$route.query.t
      };

      let url = config.apis.editClue;
      // 1 报道
      if (this.pageType === 1) {
        url = config.apis.saveReport;
      }

      // 2 发布
      else if (this.pageType === 2) {
        url = config.apis.publish_edit;
        let newObj = {
          depart_id: this.select.depart.id,
          depart_title: this.select.depart.text
        };

        Object.assign(info, newObj);
      }

      return common.myFetch(url, info).then(r => {
        if (r) {
          const id = r.report_id || r.id || r.publish_id;
          this.passPid(id);
          this.pageId = id;
          this.addHrefId(id);
          this.getPageIdPromise = null;
          return id;
        }
      });
    },
    addHrefId(id) {
      // 获取到id后添加到url上
      if (window.location.href.indexOf("d=") < 0) {
        if (window.location.href.indexOf("?") < 0) {
          // window.location.href += `?d=${id}`;
          this.$router.push(window.location.pathname + `?d=${id}`)
        } else {
          // window.location.href += `&d=${id}`;
          const i = window.location.href.indexOf("?")
          const t = window.location.href.substring(i)
          this.$router.push(window.location.pathname + t + `&d=${id}`)
        }
      }
    },
    fold() {
      // 折叠
      this.folding = !this.folding;

      this.$nextTick(() => {
        this.$emit("getFold", this.folding);
      });
    },

    async addAssetsToPage(data) {
      let tmpId = this.pageId || this.$route.query.d;
      if (!tmpId && this.getPageIdPromise) {
        tmpId = await this.getPageIdPromise;
      }

      const filelist = [];
      data.forEach(i => {
        const type = this.checkFileType(i);
        // 将文件名改为截取前40位加后缀名
        const fileName = i.pureName || i.title || i.name || "";
        const nameParts = fileName.split(".");
        const ext = nameParts.pop();
        let nameLeft = nameParts.join(".");
        nameLeft = nameLeft.substr(0, 40);
        const filetitle = `${nameLeft}.${ext}`;

        const file = {
          type: type,
          title: filetitle,
          path: i.targetPath || i.path,
          subject_id: tmpId,
          subject_type: this.pageType
        };

        filelist.push(file);
      });

      const info = { file_info: JSON.stringify(filelist) };
      return common.myFetch(config.apis.File_add, info).then(r => {
        if (r) {
          // console.log(r)
          if(this.localUploadCover){
            if(this.isPublishSrc){
              this.$emit("setNewPublishCover", r.list[0])
            }else{
              this.$emit("setNewCover", r.list[0].cover)
            }
          }
          this.getFileAssets();
        }
      });
    },
    async getFileAssets(fromSocket = false) {
      // 通过接口获取当前稿件多媒体素材列表
      this.pageId = this.$route.query.d || "";
      if (!this.pageId) return;

      const info = {
        subject_id: this.pageId,
        subject_type: this.pageType
      };

      const files = await common
        .myFetch(config.apis.File_status, info)
        .then(r => r);
      const imgs = files.img_list.map(i => {
        i.name = i.title;
        i.zoomStatus = false;
        return i;
      });
      const videos = files.video_list.map(i => {
        i.name = i.title;
        i.zoomStatus = false;
        return i;
      });
      const audios = files.sound_list.map(i => {
        i.name = i.title;
        i.zoomStatus = false;
        return i;
      });

      // this.pic.assets = Array.from(new Set(this.pic.assets.concat(imgs)))
      // this.video.assets = Array.from(new Set(this.video.assets.concat(videos)))
      // this.audio.assets = Array.from(new Set(this.audio.assets.concat(audios)))
      console.log(imgs)
      this.pic.assets = imgs;
      this.video.assets = videos;
      this.audio.assets = audios;

      const leftWithoutPending = this.file.list.filter(
        l => !l.pending && !l.hideasset
      ).length;

      if (leftWithoutPending === 0 && !fromSocket) {
        // 所有文件都已上传完毕
        // this.uploading = false
        // this.passUploading()
        this.$toast("所有文件已上传完成", 1000);
      }
    },
    deleteAsset(idstring, list) {
      // 删除资源文件
      const pageId = this.pageId || this.$route.query.d;
      const info = {
        idstring: idstring,
        subject_id: pageId,
        subject_type: this.pageType
      };
      common.myFetch(config.apis.File_delete, info).then(r => {
        if (r) {
          this.$toast(r);

          list.some((d, i) => {
            if (d.idstring === idstring) {
              list.splice(i, 1);
              // 通知编辑器 删除 该素材
              this.$emit("deleteMedia", {
                src: d.url,
                idstring,
                type: this.navOn
              });
              return true;
            }
          });
        }
      });
    },
    renameAsset(idstring, name, list) {
      // 重命名资源
      if (!name) return;
      const info = {
        idstring: idstring,
        title: name
      };

      common.myFetch(config.apis.File_rename, info).then(r => {
        if (r) {
          this.$toast(r);

          list.forEach((d, i) => {
            if (d.idstring === idstring) {
              this.$set(d, "name", name);
            }
          });
        }
      });
    },
    insertPage(asset, type) {
      if (
        asset.type != 1 &&
        (!asset.content || asset.content.status != 1 || !asset.url)
      ) {
        this.$toast("转码中，暂时不能插入正文");
        return;
      }
      // 将资源插入稿件
      const dom = {
        url: asset.url,
        cover: asset.cover,
        title: asset.name || asset.title,
        idstring: asset.idstring,
        type: type
      };

      this.$emit("getInsert", dom);
      this.$toast("插入成功");
    },
    convertWord(f) {
      // 音视频转文字
      if (!f.content || f.content.status != 1) {
        this.$toast("转码中，暂时无法转文字");
        return;
      }

      const info = {
        idstring: f.idstring
      };

      common.myFetch(config.apis.File_convert, info).then(r => {
        if (r) {
          this.$toast(r);

          this.$set(f, "text_status", 2);
        }
      });
    },
    passPid(id) {
      // 向外传送临时id
      this.$emit("getPid", id);
    },
    navSwitch(n) {
      this.navOn = n;
    },
    init() {
      // 模块初始化
      this.pageId = this.$route.query.d || "";
      this.load().then(() => {
        // this.configPic()
        // this.configVideo()
        // this.configAudio()
        this.configFile();
        console.log("init", this.hasHttp, this.hasAspera);
        if (this.hasHttp) {
          this.uploadChannel = "http";
        } else if (this.hasAspera) {
          // this.uploadChannel = "aspera";
        }
      });
    },
    receiveData() {
      // 接收已绑定数据
      console.log(22, this.data);
      if (!this.data) return;
      const data = this.data;
      const imgs = [];
      const videos = [];
      const audios = [];

      data.img.forEach(j => {
        this.pic.assets.forEach(i => {
          if (i.idstring === j.idstring) {
            j.repeat = true;
          }
        });
        if (!j.repeat) {
          imgs.push(j);
        }
      });
      this.pic.assets = this.pic.assets.concat(imgs);
      this.pic.assets.forEach((el) => {
        el.zoomStatus = false
      })

      data.video.forEach(j => {
        this.video.assets.forEach(i => {
          if (i.idstring === j.idstring) {
            j.repeat = true;
          }
        });
        if (!j.repeat) {
          videos.push(j);
        }
      });
      this.video.assets = this.video.assets.concat(videos);
      this.video.assets.forEach((el) => {
        el.zoomStatus = false
      })

      data.audio.forEach(j => {
        this.audio.assets.forEach(i => {
          if (i.idstring === j.idstring) {
            j.repeat = true;
          }
        });
        if (!j.repeat) {
          audios.push(j);
        }
      });
      this.audio.assets = this.audio.assets.concat(audios);
      this.audio.assets.forEach((el) => {
        el.zoomStatus = false
      })
    },
    loadjs() {
      // 加载js文件
      if (window.Stream) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.streamjs);
    },
    load() {
      // 加载js文件
      // return common.load(config.streamjs)
      return this.getAsperaConfig().then(() => {
        return Promise.all([this.loadjs(), this.getConfig()]);
      });
    },
    getConfig() {
      return common.getFileConfigs().then(r => {
        this.baseUrl = r.url;
        this.appId = r.app_id;
        this.appSecret = r.app_secret;
        this.cancel_enable = r.cancel_enable;
        const dataConfig = {
          tokenURL: this.baseUrl + config.apis.File_get_token,
          uploadURL: this.baseUrl + config.apis.File_post,
          postVarsPerFile: {
            appId: this.appId,
            appSecret: this.appSecret
          }
        };

        Object.assign(this.baseConfig, dataConfig);
        return true;
      });
    },
    checkWaiting(l, w) {
      // 检查所选文件大小，符合条件的加入队列 (设为可见)
      w.forEach(i => {
        l.forEach(t => {
          if (t.id === i) {
            this.$set(t, "available", true);
          }
        });
      });
    },
    filterFiles(f, size) {
      // 大小超出的文件删除出去
      let files = [];
      files = f.filter(i => {
        return i.size < size;
      });

      this.file.list.forEach((j, k) => {
        let idx = files.length - 1;
        while (idx >= 0) {
          if (files[idx].name === j.name && !j.pending && !j.hideasset) {
            this.$toast("请不要同时上传相同的文件");
            files.splice(idx, 1);
          }

          idx -= 1;
        }
      });

      return files;
    },
    handleProgress(l, f) {
      // 控制进度条
      l.forEach(i => {
        if (i.id === f.id) {
          console.log("progress", f);
          this.$set(i, "percent", f.percent);
          this.$set(i, "total", f.formatSize);
          this.$set(i, "loaded", f.formatLoaded);
        }
      });
    },
    newHandleProgress(l, f) {
      // 控制进度条
      l.forEach(i => {
        if (i.tid === f.tid) {
          console.log("progress", f);
          this.$set(i, "percent", f.progress);
          this.$set(i, "total", this.bytesToSize(f.size));
          this.$set(i, "loaded", this.bytesToSize(f.size * (f.progress / 100)));
        }
      });
    },
    bytesToSize(bytes) {
      if (bytes === 0) return '0 B';
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];
    },
    configPic() {
      // 配置图片
      const config = Object.assign({}, this.baseConfig, this.pic.config, common.userKeys());

      this.pic.stream = new Stream(config);
    },
    configVideo() {
      // 配置视频
      const config = Object.assign({}, this.baseConfig, this.video.config, common.userKeys());

      this.video.stream = new Stream(config);
    },
    configAudio() {
      // 配置音频
      const config = Object.assign({}, this.baseConfig, this.audio.config, common.userKeys());

      this.audio.stream = new Stream(config);
    },
    async configFile() {
      // 配置文件
      let tmpId = this.pageId || this.$route.query.d;
      if (!tmpId) {
        this.getPageIdPromise = await this.getTempId();
        tmpId = this.getPageIdPromise;
      }
      let subjectConfig = {
        subject_id: tmpId,
        subject_type: this.pageType
      }
      const config = Object.assign({}, this.baseConfig, this.file.config, common.userKeys(), subjectConfig);
      const config1 = Object.assign({}, this.baseConfig, this.file.config1, common.userKeys(), subjectConfig);
      console.log(config)
      // this.file.stream = new Stream(config);
      // this.file.stream1 = new Stream(config1);

      this.loadNewConfig().then(res => {
          console.log('loadNewConfig',res)
          this.getNewUploadConfig(res)
          this.getNewUploadImageConfig(res)
      }).catch(err => {
          this.$toast(err)
      })
    },
    async getNewUploadConfig(r) {
        if (r) {
          let tmpId = this.pageId || this.$route.query.d;
          if (!tmpId) {
            this.getPageIdPromise = await this.getTempId();
            tmpId = this.getPageIdPromise;
          }
          let subjectConfig = {
            subject_id: tmpId,
            subject_type: this.pageType
          }
            this.newConfig = r
            let image = this.newConfig.file_format.image;
            let video = this.newConfig.file_format.video;
            let audio = this.newConfig.file_format.audio;
            this.pic.types = image;
            this.video.types = video;
            this.audio.types = audio;
            let types = [];
            types = types.concat(image).concat(video).concat(audio);

            let config = {
                id: 'httpUpBtn',
                multipleUpload: true,
                chunkSize: 10,
                allowedFileTypes: types,
                check_url: this.newConfig.check_url,
                token_url: this.newConfig.token_url,
                upload_url: this.newConfig.upload_url,
                max_part_size: this.newConfig.max_part_size / 1024 / 1024,
                max_part_num: this.newConfig.max_part_num,
                max_expire_time: this.newConfig.max_expire_time,
                cancel_url: this.newConfig.cancel_url,
                noAuto: true,
                subjectConfig: subjectConfig
            }
            let upload = new Upload(config);

            // this.newUpload = upload
            this.file.stream = upload

            upload.onReady(async f => {
              console.log(f)
              let status = this.checkFileCountCancel(f);

              let materialType = false;
              f.forEach(el => {
                if(this.checkFileType(el)!=1){
                  materialType = true
                }
              })

              if (!status) {
                return;
              }

              if(this.localUploadCover && materialType){
                this.$toast('请上传图片文件')
                return;
              }

              f = this.filterFiles(f, this.file.config.maxSize);

              let totalList = this.file.list.concat(f);
              const allTypes = this.pic.types
                .concat(this.video.types)
                .concat(this.audio.types);
              totalList = totalList.filter(i => allTypes.indexOf(i.ext) > -1);
              this.file.list = Array.from(new Set(totalList));
              upload.handleHash(f)

            })

            upload.onProgress(res => {
                console.log(res)
                this.uploading = true;
                this.passUploading();
                this.newHandleProgress(this.file.list, res);
            })

            upload.onComplete(res => {
                console.log('complete',res)
                this.file.list = this.file.list.filter(i => i.tid !== res.tid);
                this.addFilePromises.push(this.addAssetsToPage([res]));
            })

            upload.onAllComplete(res => {
                
            })

            upload.onCancel((res,token) => {
                if(res){
                    console.log('cancel', res)
                    this.file.list = this.file.list.filter(i => i.tid !== res);
                }
            }) 

            upload.onError(res => {
                this.$toast(res.msg)
                if(res.tid){
                  this.file.list = this.file.list.filter(i => i.tid !== res.tid);
                }
                if(res.token){
                    this.toastCancel(res.token)
                }
                this.uploading = false;
                this.passUploading();
            })
        }
    },
    async getNewUploadImageConfig(r) {
        if (r) {
          let tmpId = this.pageId || this.$route.query.d;
          if (!tmpId) {
            this.getPageIdPromise = await this.getTempId();
            tmpId = this.getPageIdPromise;
          }
          let subjectConfig = {
            subject_id: tmpId,
            subject_type: this.pageType
          }
            this.newConfig = r
            let image = this.newConfig.file_format.image;
            let video = this.newConfig.file_format.video;
            let audio = this.newConfig.file_format.audio;
            // this.pic.types = image;
            // this.video.types = video;
            // this.audio.types = audio;
            let types = [];
            types = types.concat(image);

            let config = {
                id: 'httpUpBtn1',
                multipleUpload: false,
                chunkSize: 10,
                allowedFileTypes: types,
                check_url: this.newConfig.check_url,
                token_url: this.newConfig.token_url,
                upload_url: this.newConfig.upload_url,
                max_part_size: this.newConfig.max_part_size / 1024 / 1024,
                max_part_num: this.newConfig.max_part_num,
                max_expire_time: this.newConfig.max_expire_time,
                cancel_url: this.newConfig.cancel_url,
                noAuto: true,
                subjectConfig: subjectConfig
            }
            let upload = new Upload(config);

            // this.newUpload = upload
            this.file.stream1 = upload

            upload.onReady(async f => {

              f = this.filterFiles(f, this.file.config1.maxSize);

              let totalList = this.file.list.concat(f);
              const allTypes = this.pic.types
              totalList = totalList.filter(i => allTypes.indexOf(i.ext) > -1);
              this.file.list = Array.from(new Set(totalList));
              upload.handleHash(f)

            })

            upload.onProgress(res => {
                console.log(res)
                this.uploading = true;
                this.passUploading();
                this.newHandleProgress(this.file.list, res);
            })

            upload.onComplete(res => {
                console.log('complete',res)
                this.file.list = this.file.list.filter(i => i.tid !== res.tid);
                this.addFilePromises.push(this.addAssetsToPage([res]));
            })

            upload.onAllComplete(res => {
                
            })

            upload.onCancel((res,token) => {
                if(res){
                    console.log('cancel', res)
                    this.file.list = this.file.list.filter(i => i.tid !== res);
                }
            }) 

            upload.onError(res => {
                this.$toast(res.msg)

                if(res.token){
                    this.toastCancel(res.token)
                }
                
                this.uploading = false;
                this.passUploading();
            })
        }
    },
    toastCancel(token) {
        if(token){
            let i = {
                token: token
            }
            common.myFetch(config.apis.newUploadcancel,i).then(res => {
                console.log(res)
            })
        }
    },
    loadNewConfig() {
      return new Promise((resolve,reject) => {
          common.myFetch(config.apis.newUploadConfig).then(r => {
              console.log('getNewConfig',r)
              if(r) {
                  resolve(r)
              }else{
                  reject('上传组件加载失败')
              }
          })
      })
    },
    delItem(data, id) {
      // 从数组中移除取消上传的项
      data.forEach((d, i) => {
        if (d.id === id) {
          data.splice(i, 1);
        }
      });
    },
    getUploadingOne(all) {
      // 从uploadinfo中查找正在上传选项并返回
      let one = null;
      for (let k in all) {
        if (all.hasOwnProperty(k)) {
          if (all[k].actived) {
            one = k;
          }
        }
      }

      return one;
    },
    goAspera() {
      // 去aspera插件的下载页
      const url = config.asperajs;

      window.open(url, "", "", true);
    },
    getPureName(str, len) {
      // 将文件名去掉后缀，取指定长度
      const arr = str.split(".");
      arr.pop();
      const res = arr.join(".");

      return res.substr(0, len);
    },
    getTranscode(r) {
      // 获取视音频入库状态
      const info = r.content;
      if (info) {
        this.$toast(`${info.title}已入库`);
        this.getFileAssets(true);
      }
    },
    getComposite(r) {
      // 获取音频合成状态
      this.$toast("合成音频完成");
      this.getFileAssets(true);
    },
    getFakeComposite(r) {
      // 获取假的音频合成状态
      this.getFileAssets(true);
    },
    getTranstext(r) {
      // 获取转文字状态
      this.$toast("转文字完成");
      this.getFileAssets(true);
    },
    getFlashfile(r) {
      console.log("getFlashfile11111111");
      this.getFileAssets(true);
    },
    async showMaterialListBox1(materialChannel,showMore,isPublishSrc) {
      let link = false
      if(this.$route.name == 'editPublish' || this.$route.name == 'createPublish' || this.$route.name == 'creatReport' || this.$route.name == 'editReport' || this.$route.name == 'creatClue' || this.$route.name == 'editClue' || this.$route.path == '/editReport' || this.$route.path == '/editClue' || this.$route.path == '/createPublish'){
        link = true
      }
      let id = this.pageId || this.$route.query.d || (await this.getTempId());
      this.materialChannel = materialChannel;
      this.showMore = showMore;
      let config = {
        subject_id: id, //文稿的id
        subject_type: this.pageType,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        d: this.$route.query.d,
        materialChannel: this.materialChannel,
        showMore: this.showMore,
        link: link,
        upload_limit_num: this.upload_limit_num,
        isPublishSrc: isPublishSrc
      };
      console.log(config)
      return this.$materialListBox(config).then(res => {
        if (res) {
          this.getFlashfile();
          console.log(res)
          return res
          // this.getFlashfile();
        }
      });
    },
    // 打开我的素材
    async showMaterialListBox() {
      console.log(this.$route)
      let link = false
      if(this.$route.name == 'editPublish' || this.$route.name == 'createPublish' || this.$route.name == 'creatReport' || this.$route.name == 'editReport' || this.$route.name == 'creatClue' || this.$route.name == 'editClue' || this.$route.path == '/editReport' || this.$route.path == '/editClue' || this.$route.path == '/createPublish'){
        link = true
      }
      let id = this.pageId || this.$route.query.d || (await this.getTempId());
      let config = {
        subject_id: id, //文稿的id
        subject_type: this.pageType,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        d: this.$route.query.d,
        materialChannel: this.materialChannel,
        showMore: this.showMore,
        video: this.video,
        audio: this.audio,
        list: this.file.list,
        link: link,
        upload_limit_num: this.upload_limit_num
      };
      console.log(config)
      this.$materialListBox(config).then(res => {
        if (res) {
          this.getFlashfile();
        }
      });
    },
    /**
     * 选用 为快编素材
     */
    addQKFile({ id }, type) {
      console.log("addQKFile  file id", id);
      console.log("addQKFile type", type);
      let data = {
        file_ids: id
      };
      common.myFetch(config.apis.File_addquickfile, data).then(res => {
        console.log("File_addquickfile res", res);
        if (res) {
          this.$toast("已成功加入选用素材");
        }
      });
    },
    zoomIn(e) {
      let item = e.target;
      let children = item.children;
      let parent = item.parentNode.parentNode.children;
      let cover = '';
      let mask = '';
      for (let child of children) {
        if (child.classList.contains("cover")) {
          cover = child;
        }
      }

      for (let child of parent) {
        if (child.classList.contains("info")) {
          mask = child;
        }
      }

      cover.classList.add("zoom");
      mask.classList.add("show");
    },
    zoomOut(e) {
      let item = e.target;
      let children = item.children;
      let parent = item.parentNode.parentNode.children;
      let cover = '';
      let mask = '';
      for (let child of children) {
        if (child.classList.contains("cover")) {
          cover = child;
        }
      }

      for (let child of parent) {
        if (child.classList.contains("info")) {
          mask = child;
        }
      }

      cover.classList.remove("zoom");
      mask.classList.remove("show");
    }
  },

  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.defaultMedia = this.$_syscfg.default_media
    this.init();
    common.handleSocket(this.getTranscode, "transcode");
    common.handleSocket(this.getComposite, "makeupaudio");
    common.handleSocket(this.getComposite, "speech_tts");
    common.handleSocket(this.getFakeComposite, "fakemakeupaudio");
    common.handleSocket(this.getTranstext, "pickuptext");
    common.handleSocket(this.getFlashfile, "flashfile");
    window['getSonData'] = (val) => {
      this.getFlashfile()
    }
    // this.$picEditType(1, 2).then((res) => {

    // })
  },
  created() {
    this.pageId = this.$route.query.d || "";
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/global.less";

.aside-content {
  background: @bg;
  box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
  border-radius: 4px;
  flex: 1;
  overflow: hidden;
}

.folded {
  flex: none !important;

  .nav {
    dl {
      border-bottom: none !important;
    }
  }
}

.nav {
  width: 100%;
  box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
  border-radius: 4px 4px 0 0;
  .titleline {
    justify-content: space-between;
    h5 {
      display: flex;
      font-size: 16px;
      img {
        margin-left: 5px;
      }
      .tip {
        cursor: pointer;
      }
      .tips {
        display: none;
        position: absolute;
        margin: 6px 0 0;
        width: 100%;
        top: 40px;
        left: 0;
        line-height: 18px;
        border-radius: 4px;
        background-color: rgba(5, 15, 15, 0.8);
        padding: 16px 20px;
        z-index: 2;
        overflow: hidden;
        color: @dateColor;
        font-size: 13px;
        word-break: break-all;
      }
      &:hover {
        .tips {
          display: block;
        }
      }
    }
    span {
      display: flex;
      cursor: pointer;
      align-items: center;
      img {
        margin-left: 10px;
      }
    }
  }

  .upFile {
    display: flex;
    padding: 20px;
    .hide {
      display: none !important;
    }

    .btn-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .upload-container {
        position: relative;
        width: 142px;
        height: 30px;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border: 1px solid rgba(65, 180, 140, 0.4);
        padding: 0 10px 0 24px;
        font-size: 14px;
        color: @green;
        box-sizing: border-box;
        user-select: none;
        cursor: pointer;

        .localUpload {
          width: 142px;
          height: 30px;
          border-radius: 4px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }

        .asperaUpload {
          width: 142px;
          height: 30px;
          border-radius: 4px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }

        img {
          &:nth-last-of-type(1) {
            transform: rotate(180deg);
          }
        }

        &.rotate {
          background: rgba(65, 180, 140, 0.15);
          border: 1px solid rgba(65, 180, 140, 0.4);
          box-sizing: border-box;

          img {
            &:nth-last-of-type(1) {
              transform: rotate(0deg);
            }
          }

          .formatList {
            // display: flex;
          }
        }

        .formatList {
          // display: none;
          flex-direction: column;
          position: absolute;
          top: 30px;
          left: 0;
          z-index: 99;

          & > p {
            width: 100%;
            height: 4px;
          }

          .format {
            display: flex;
            flex-direction: column;
            width: 142px;
            border-radius: 4px;
            background-color: rgba(5, 15, 15, 0.8);

            & > div {
              width: 142px;
              min-height: 40px;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              font-size: 13px;
              color: #fff;

              &:hover {
                background: rgba(255, 255, 255, 0.1);
              }

              img {
                margin-right: 10px;
              }
            }
          }
        }
      }

      .material-container {
        // width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        // &:hover {

        //   background: rgba(65, 180, 140, 0.15);
        //   // border: 1px solid rgba(65, 180, 140, 0.4);
        //   box-sizing: border-box;

        //   .material {
        //     img {
        //     &:nth-last-of-type(1) {
        //       transform: rotate(0deg);
        //     }
        //   }
        //   }
          

        //   // .formatList {
        //   //   display: flex;
        //   // }
        // }

        .rotate {

          background: rgba(65, 180, 140, 0.15);
          // border: 1px solid rgba(65, 180, 140, 0.4);
          box-sizing: border-box;

          &.material {
            img {
            &:nth-last-of-type(1) {
              transform: rotate(0deg);
            }
          }
          }
          

          // .formatList {
          //   display: flex;
          // }
        }

        .material {
          position: relative;
          width: 142px;
          height: 30px;
          border-radius: 4px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          // background: rgba(65, 180, 140, 0.15);
          border: 1px solid rgba(65, 180, 140, 0.4);
          font-size: 14px;
          color: @green;
          padding: 0 10px 0 24px;
          box-sizing: border-box;
          user-select: none;
          cursor: pointer;

          &.materialBin {
            padding: 0 10px 0 31px;
          }

          p {
            min-width: 56px;
          }

          img {
            &:nth-last-of-type(1) {
              transform: rotate(180deg);
            }
          }

          &:hover {
            .formatList {
              display: flex;
            }
          }
        }

        .formatList {
            // display: none;
            flex-direction: column;
            position: absolute;
            top: 30px;
            left: 0;
            z-index: 99;

            & > p {
              width: 100%;
              height: 4px;
            }

            .format {
              display: flex;
              flex-direction: column;
              width: 142px;
              border-radius: 4px;
              background-color: rgba(5, 15, 15, 0.8);

              & > div {
                width: 142px;
                min-height: 40px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                font-size: 13px;
                color: #fff;
                cursor: pointer;

                p {
                  min-width: 52px;
                }

                &:hover {
                  background: rgba(255, 255, 255, 0.1);
                }

                img {
                  margin-right: 10px;
                }
              }
            }
          }
      }
    }

    .httpUpBtn,
    .AsperaUpBtn {
      line-height: 30px;
      background-color: rgba(65, 180, 140, 0.15);
      border: 1px solid rgba(65, 180, 140, 0.4);
      border-radius: 4px;
      width: 96px;
      height: 30px;
      font-size: 14px;
      color: @green;
      // margin-right: 30px;
      background-image: url("../assets/img/common/add-green.svg");
      background-repeat: no-repeat;
      background-position: 18px center;
      text-align: left;
      text-indent: 40px;
      cursor: pointer;
    }

    .disabled {
      background-color: #e6e6e6;
      border-color: #dcdcdc;
      color: @dateColor;
      background-image: url("../assets/img/common/add-gray.svg");
      cursor: not-allowed;
    }

    .installBtn {
      background-color: rgba(65, 180, 140, 0.15);
      border: 1px solid rgba(65, 180, 140, 0.4);
      border-radius: 4px;
      width: 96px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: @green;
      text-align: center;
      cursor: pointer;
    }

    .asperaHelp {
      position: absolute;
      right: 0;
      top: 12px;
      // margin-left: 4px;
      width: 16px;
      height: auto;
      cursor: pointer;
      transform: rotate(0deg) !important;
    }

    .radio {
      display: flex;
      align-items: center;
      flex: 1;

      .radioBtn {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 18px;

        &:nth-of-type(1) {
          margin-right: 15px;
        }

        &.active {
          span {
            position: relative;
            background: #41b48c;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 10px !important;

            &:after {
              display: block;
              content: "";
              position: absolute;
              top: 50%;
              left: 50%;
              width: 6px;
              height: 6px;
              background: #fff;
              margin-top: -3px;
              margin-left: -3px;
              border-radius: 50%;
              overflow: hidden;
            }
          }
        }

        span {
          width: 16px;
          height: 16px;
          background: #dcdcdc;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px !important;
        }

        p {
          font-size: 14px;
          line-height: 18px;
          color: #41b48c;
          cursor: pointer;
        }
      }

      span {
        font-size: 14px;
        color: @sub;
        white-space: nowrap;
        display: flex;
        align-items: center;

        &.active {
          color: @green;
        }
        &:first-child {
          margin-right: 20px;
        }
        input {
          margin-right: 10px;
        }
      }
    }
  }

  .upload {
    // margin-top: 20px;
    overflow-x: auto;
    padding: 0 20px;
    .uploadList {
      display: flex;
      width: auto;
      max-height: 72px;
    }
    .pdt_10 {
      padding-top: 10px;
    }
    .item {
      flex-shrink: 0;
      width: 112px;
      height: 62px;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-right: 10px;

      .pending {
        color: #fff;
        font-size: 13px;
      }
      .proportion {
        font-size: 10px;
        color: #fff;
        margin-bottom: 6px;
      }

      .speed-box {
        width: 70px;
        height: 5px;
        display: block;
        border: 1px solid #ffffff;
        border-radius: 100px;
        overflow: hidden;

        span {
          display: block;
          width: 0%;
          height: 5px;
          background: #ffffff;
          // border:1px solid #ffffff;
          border-radius: 3px 0 0 3px;
        }
      }
      .close {
        display: block;
        width: 14px;
        height: 14px;
        text-align: center;
        color: #fff;
        position: absolute;
        right: -7px;
        top: -7px;
        border-radius: 50%;
        background-image: url("../assets/img/common/gb.svg");
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
      }
    }
  }

  dl {
    height: 50px;
    border-bottom: 1px solid @dc;
    display: flex;
    padding: 0px 20px;
    align-items: center;
    color: @dark;

    h4 {
      flex: 1;
    }
    span {
      font-size: 18px;
      display: flex;
      align-items: center;

      i {
        display: inline-block;
        width: 10px;
        height: 6px;
        background: url("../assets/img/common/down.png") no-repeat;
        background-size: 100%;
        margin-left: 8px;
        transform: rotate(-180deg);
      }
    }
  }
  ul {
    display: flex;

    li {
      line-height: 50px;
      text-align: center;
      flex: 1;
      font-size: 16px;
      color: @dark;
      position: relative;
      cursor: pointer;

      &::after {
        content: "";
        display: block;
        width: 1px;
        height: 17px;
        background: @dc;
        position: absolute;
        right: 0px;
        top: 0px;
        bottom: 0px;
        margin: auto;
      }

      &:last-of-type {
        &::after {
          display: none;
        }
      }

      &.active {
        color: @green;
        border-bottom: 2px solid @green;

        span {
          color: @green;
        }
      }
      span {
        color: @sub;
      }
    }
  }
}
.nav-content {
  flex: 1;
  overflow-y: auto;
  .nav-item {
    padding: 20px;

    .item {
      ul {
        li {
          &.upFile {
            display: flex;

            span {
              line-height: 18px;
              font-size: 13px;
              color: @dateColor;
              text-align: justify;
              display: flex;
              align-items: center;

              button {
                background-color: rgba(65, 180, 140, 0.15);
                border: 1px solid rgba(65, 180, 140, 0.4);
                border-radius: 4px;
                width: 112px;
                height: 30px;
                font-size: 14px;
                color: @green;
                margin-right: 30px;
                background-image: url("../assets/img/common/add-green.svg");
                background-repeat: no-repeat;
                background-position: 18px center;
                text-align: left;
                text-indent: 40px;
              }
            }

            &.video {
              flex-wrap: wrap;

              span {
                flex: 1;

                &.upBtn {
                  justify-content: flex-end;

                  button {
                    margin: 0px;
                  }
                }
                &.video {
                  flex: 0 100%;
                  word-break: break-all;
                  margin-top: 20px;
                }
              }
              .radio {
                display: flex;
                align-items: center;
                span {
                  font-size: 14px;
                  color: @sub;

                  &.active {
                    color: @green;
                  }
                  &:last-child {
                    margin-left: 60px;
                  }
                  input {
                    margin-right: 10px;
                  }
                }
              }
            }
          }
          &.upload {
            margin-top: 20px;
            overflow-x: auto;
            .uploadList {
              display: flex;
              width: auto;
              max-height: 72px;
              padding-top: 10px;
            }
            .item {
              flex-shrink: 0;
              width: 112px;
              height: 62px;
              background: rgba(0, 0, 0, 0.7);
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              margin-right: 10px;

              .pending {
                color: #fff;
                font-size: 13px;
              }

              .speed-box {
                width: 70px;
                height: 5px;
                display: block;
                border: 1px solid #ffffff;
                border-radius: 100px;
                overflow: hidden;

                span {
                  display: block;
                  width: 0%;
                  height: 5px;
                  background: #ffffff;
                  // border:1px solid #ffffff;
                  border-radius: 3px 0 0 3px;
                }
              }
              .close {
                display: block;
                width: 14px;
                height: 14px;
                text-align: center;
                color: #fff;
                position: absolute;
                right: -7px;
                top: -7px;
                border-radius: 50%;
                background-image: url("../assets/img/common/gb.svg");
                background-repeat: no-repeat;
                background-position: center;
                cursor: pointer;
              }
            }
          }
          &.list:first-child {
            margin-top: 0;
            border-top: none;

            .info {
             top: 0; 
            }
          }
          &.list {
            position: relative;
            border-top: 1px solid @dc;
            margin-top: 20px;
            padding-top: 20px;
            // flex-wrap: wrap;
            &:nth-of-type(1) {
              padding-top: 0px;
            }
            .row {
              width: 100%;
              display: flex;
            }

            .row1 {
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .append {
                width: 48%;
                flex-grow: 0;
                &.big {
                  width: 100%;
                }
                &.border {
                  button {
                    background: #fff;
                    color: #41b48c;
                    border: 1px solid #41b48c;
                  }
                }
              }
            }

            .info {
              &.show {
                display: flex;
              }

              display: none;
              flex-direction: column;
              position: absolute;
              top: 20px;
              left: 86px;
              width: 220px;
              height: 45px;
              background: rgba(5, 15, 15, 0.8);
              border-radius: 4px;
              padding: 3px 10px;
              box-sizing: border-box;

              ul {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                &.bottom {
                  margin-bottom: 4px;
                }

                li {
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  p {
                    font-size: 12px;
                    line-height: 17px;
                    color: #B9C3C3;
                    margin-right: 8px;
                  }

                  span {
                    font-size: 12px;
                    line-height: 17px;
                    color: #FFF;
                  }
                }
              }
            }

            .pic {
              display: flex;
              align-items: center;

              // flex: 0 80px;
              flex-shrink: 0;
              width: 80px;
              height: 45px;
              overflow: hidden;
              margin-right: 16px;
              position: relative;
              cursor: pointer;
              border-radius: 4px;
              .play {
                position: absolute;
                width: 40px;
                height: 40px;
                top: 10px;
                left: 10px;
                right: 0;
                bottom: 0;
                margin: auto;
                z-index: 1;
              }
              .cover {
                width: 100%;
                object-fit: cover;
                transition: all 0.5s;
                &.zoom {
                  transform: scale(1.3);
                }
              }
              .mask {
                display: none;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 99999999;
                width: 80px;
                height: 45px;
                line-height: 45px;
                text-align: center;
                background: rgba(0, 0, 0, 0.7);
                border-radius: 4px;
                font-size: 12px;
                color: #FFFFFF;
                font-weight: bold;
              }
              &:hover {
                .mask {
                  display: block;
                }
              }
              .verify-item {
                position: absolute;
                left: 0;
                top: 0;
                background-color: @green;
                width: 20px;
                height: 20px;
                border-radius: 0 0 100% 0;
                z-index: 1;
                line-height: 10px;
                &.verify-fail {
                  background-color: #ff3e53;
                }
                img {
                  padding: 2px;
                }
              }
            }
            &.wengao {
              padding: 18px 0px;
              margin: 0px;
              border: none;
              border-bottom: 1px solid @dc;

              &:last-of-type {
                border: none;
                padding-bottom: 0px;
              }
              .pic {
                flex: 0 34px;
                height: 40px;
                background: url("../assets/img/common/wengao.svg") no-repeat;
                background-size: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 14px;

                &.on {
                  opacity: 0.5;
                }
              }
              .c {
                border: none;
                display: block;

                .speed-box {
                  width: 100%;
                  height: 8px;
                  background: rgba(185, 195, 195, 0.2);
                  border-radius: 100px;
                  margin-top: 10px;
                  overflow: hidden;

                  .speed {
                    width: 0;
                    display: block;
                    height: 8px;
                    background: @green;
                    border-radius: 100px 0 0 100px;
                  }
                }
              }
            }
            .c {
              display: flex;
              border-bottom: 1px solid @dc;
              flex: 1;
              overflow: hidden;

              .t {
                font-size: 14px;
                flex: 1;
                resize: none;
                background-color: transparent;
                &::-webkit-scrollbar {
                  width: 0;
                  height: 0;
                }
              }
              .size {
                width: 40px;
                font-size: 14px;
                color: @dateColor;
                text-align: right;
              }
            }
            .rm {
              // flex: 0 20px;
              margin-left: 10px;

              span {
                display: block;
                width: 19px;
                height: 19px;
                background: url("../assets/img/common/rm.svg") no-repeat;
                background-size: 100%;
                cursor: pointer;
              }
            }
            .append {
              width: 100%;
              flex-grow: 3;
              margin-top: 20px;
              position: relative;

              .detail {
                display: none;
                position: absolute;
                margin: 10px 0 0;
                width: 100%;
                left: 0;
                height: 110px;
                border-radius: 4px;
                background-color: rgba(5, 15, 15, 0.8);
                padding: 14px 20px;
                z-index: 2;
                overflow: hidden;
                .line {
                  width: 100%;
                  height: 26px;
                  display: flex;
                  justify-content: space-between;
                  .item {
                    text-indent: 0;
                    width: 50%;
                    text-align: left;
                    font-size: 13px;
                    color: @dateColor;
                    white-space: nowrap;
                    // overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    span {
                      text-align: left;
                    }
                    .txt {
                      margin-left: 10px;
                      font-size: 14px;
                      color: #fff;
                    }
                  }
                  // .item:nth-child(2n) {
                  //   // justify-content: center;
                  //   width: 28%;
                  // }
                  // .item:nth-child(3n) {
                  //   justify-content: flex-end;
                  // }
                }
              }

              button {
                width: 100%;
                height: 30px;
                border-radius: 4px;
                background: @green;
                border: none;
                font-size: 14px;
                color: #ffffff;
              }

              &.video {
                display: flex;
                button {
                  width: 94px;
                  margin-right: 8px;
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  &.buttonHasEdit {
                    width: 82px;
                    height: 30px;
                    font-size: 14px;
                    margin-right: 8px;
                  }

                  &.smallButtonHasEdit {
                    width: 64px;
                    height: 30px;
                    background: none;
                    border: 1px solid @green;
                    color: @green;
                  }

                  &.longButtonHasEdit {
                    width: 105px;
                    height: 30px;
                    background: none;
                    border: 1px solid @green;
                    color: @green;
                  }

                  &:last-child {
                    margin: 0px;
                    background: none;
                    border: 1px solid @green;
                    color: @green;
                  }
                  .loading {
                    width: 28px;
                    margin-right: 4px;
                  }
                }
                .de {
                  background-color: rgba(185, 195, 195, 0.2);
                  border-radius: 4px;
                  width: 80px;
                  color: @sub;
                  text-align: left;
                  text-indent: 24px;
                  background-image: url("../assets/img/common/warning.svg");
                  background-repeat: no-repeat;
                  background-size: 15px;
                  background-position: 14px center;
                  margin-right: 20px;

                  &.hasEdit {
                    width: 64px;
                    height: 30px;
                    background-color: rgba(185, 195, 195, 0.2);
                    border-radius: 4px;
                    color: @sub;
                    text-align: left;
                    text-indent: 18px;
                    background-image: url("../assets/img/common/warning.svg");
                    background-repeat: no-repeat;
                    background-size: 14px;
                    background-position: 9px center;
                    margin-right: 8px;
                  }

                  &:hover {
                    .detail {
                      display: block;
                    }
                  }
                }
                .fail {
                  color: @red !important;
                  border-color: @red !important;
                  &:hover {
                    color: @green !important;
                    border-color: @green !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
